import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomizeHomePageCreationComponent } from './components/customize-homepage-creation/customize-homepage-tab.component';
import { CustomizeHomepageComponent } from './customize-homepage.component';
import { CustomizeHomePageService } from './customize-homepage.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AppSharedModule } from './../shared/appShared.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';

@NgModule({ declarations: [
        CustomizeHomePageCreationComponent,
        CustomizeHomepageComponent
    ],
    bootstrap: [CustomizeHomePageCreationComponent, CustomizeHomepageComponent],
  imports: [
    BrowserModule,
    ConfirmDialogModule,
    TranslatePipe, TranslateDirective,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    AppSharedModule,
    RouterModule
  ],
  providers: [CustomizeHomePageService, provideHttpClient(withInterceptorsFromDi())]
})
export class CustomizeHomepageModule {}
